import React from "react";
import { Box, Typography } from "@mui/material";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import DebouncedInput from "../../../../common/components/DebouncedTextfield";

const ThirdStep = ({ agent, openNav, closeNav, openBigTextArea, setAgent }) => {
  return (
    <>
      {openBigTextArea(() => closeNav(2), "rules", agent?.rules, 2)}
      <Box>
        <Typography className="font-14-grey" gutterBottom>
          Rules the output should follow
        </Typography>

        <DebouncedInput
          initialValue={agent?.rules}
          onDebouncedUpdate={(val) =>
            setAgent((prev) => ({ ...prev, rules: val }))
          }
          sx={commonStyles.inputField}
        />

        <span className="icon1" onClick={() => openNav(2)}>
          <span className="fas fa-expand"></span>
        </span>
      </Box>
    </>
  );
};

export default ThirdStep;
